<template>

    <div class="top-0 w-full bg-white border-b border-gray-200 z-10">
        <div class="flex justify-between  items-center  lg:max-w-5xl w-[90%] mx-auto h-full">

            <div class="py-3"><img class="w-3/6" src="../assets/giftyLogo.png" alt="Logo"></div>

            <div ref="dropdownRef" class="relative h-full">
                <div @click="toggleDropdown"
                    class="flex justify-center items-center gap-2 px-3 h-full border-none rounded-lg hover:bg-gray-50 transition">
                    <component :is="currentLocaleObject.icon" class="w-5 h-5" />
                    <div class="text-sm font-medium">{{ currentLocaleLabel }}</div>
                </div>

                <div v-if="open"
                    class="absolute right-0 mt-2 w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                    <div v-for="locale in locales" :key="locale.code" @click="changeLocale(locale.code)"
                        class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex justify-start   items-center gap-3">
                        <component :is="locale.icon" class="w-5 h-5" />
                        <div>{{ locale.label }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import fr_icon from './icons/fr_icon.vue'
import dz_icon from './icons/dz_icon.vue'



const open = ref(false)
const currentLocale = ref('fr')

const { locale } = useI18n()

const locales = [
    { code: 'ar', label: 'العربية', icon: dz_icon },
    { code: 'fr', label: 'Français', icon: fr_icon }];

const currentLocaleLabel = computed(() => {
    return locales.find(l => l.code === currentLocale.value)?.label || 'Langue'
})


const currentLocaleObject = computed(() =>
    locales.find(l => l.code === currentLocale.value)
)
function toggleDropdown() {
    open.value = !open.value
}

function changeLocale(code) {
    currentLocale.value = code
    open.value = false
    locale.value = code
}


function handleClickOutside(event) {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        open.value = false
    }
}
const dropdownRef = ref(null)

onMounted(() => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside))
</script>
